import moment from 'moment-timezone';
import {
  DAILY_TIME_HOUR_OPTIONS,
  DAILY_TIME_MINUTE_OPTIONS,
  DAILY_TIME_PERIOD_OPTIONS,
  TIME_PICKER_FORMAT,
  DB_TIME_FORMAT
} from 'common/constants/constants';
import { getTimezone, formatDateToUTC } from 'common/utils/utils';
import {
  LBSelect,
  LBSelectContent,
  LBSelectGroup,
  LBSelectItem,
  LBSelectTrigger,
  LBSelectValue
} from '@linearb/buzz';

const TimePicker = ({ time, onChange, dataCy = '' }) => {
  const timePickerChanged = (value, type) => {
    const hour =
      type === 'hh' ? value : moment(time, TIME_PICKER_FORMAT).format('hh');
    const minute =
      type === 'mm' ? value : moment(time, TIME_PICKER_FORMAT).format('mm');
    const period =
      type === 'a' ? value : moment(time, TIME_PICKER_FORMAT).format('a');
    const timeStr = `${hour}:${minute} ${period}`;
    onChange(
      timeStr,
      formatDateToUTC(timeStr, TIME_PICKER_FORMAT, DB_TIME_FORMAT)
    );
  };

  return (
    <>
      <LBSelect
        value={time ? moment(time, TIME_PICKER_FORMAT).format('hh') : null}
        onValueChange={selected => {
          timePickerChanged(selected, 'hh');
        }}
      >
        <LBSelectTrigger data-cy={`${dataCy}-hour-dropdown`}>
          <LBSelectValue />
        </LBSelectTrigger>
        <LBSelectContent>
          <LBSelectGroup>
            {DAILY_TIME_HOUR_OPTIONS.map(option => (
              <LBSelectItem value={option.value} key={option.value}>
                {option.displayValue}
              </LBSelectItem>
            ))}
          </LBSelectGroup>
        </LBSelectContent>
      </LBSelect>

      <span>:</span>

      <LBSelect
        value={time ? moment(time, TIME_PICKER_FORMAT).format('mm') : null}
        onValueChange={selected => {
          timePickerChanged(selected, 'mm');
        }}
      >
        <LBSelectTrigger data-cy={`${dataCy}-minutes-dropdown`}>
          <LBSelectValue />
        </LBSelectTrigger>
        <LBSelectContent>
          <LBSelectGroup>
            {DAILY_TIME_MINUTE_OPTIONS.map(option => (
              <LBSelectItem value={option.value} key={option.value}>
                {option.displayValue}
              </LBSelectItem>
            ))}
          </LBSelectGroup>
        </LBSelectContent>
      </LBSelect>

      <LBSelect
        value={time ? moment(time, TIME_PICKER_FORMAT).format('a') : null}
        onValueChange={selected => {
          timePickerChanged(selected, 'a');
        }}
      >
        <LBSelectTrigger data-cy={`${dataCy}-am-pm-dropdown`}>
          <LBSelectValue />
        </LBSelectTrigger>
        <LBSelectContent>
          <LBSelectGroup>
            {DAILY_TIME_PERIOD_OPTIONS.map(option => (
              <LBSelectItem value={option.value} key={option.value}>
                {option.displayValue}
              </LBSelectItem>
            ))}
          </LBSelectGroup>
        </LBSelectContent>
      </LBSelect>

      <span className='text-base'>{getTimezone()}</span>
    </>
  );
};

export default TimePicker;
